// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Reader_Class from "../Control.Monad.Reader.Class/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Lens_Index from "../Data.Lens.Index/index.js";
import * as Data_Lens_Setter from "../Data.Lens.Setter/index.js";
import * as Data_LoadDirection from "../Data.LoadDirection/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Profunctor_Choice from "../Data.Profunctor.Choice/index.js";
import * as Data_Profunctor_Strong from "../Data.Profunctor.Strong/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Data_FSError from "../Fusion.Data.FSError/index.js";
import * as Fusion_Data_FSValue from "../Fusion.Data.FSValue/index.js";
import * as Fusion_Data_Timestamp from "../Fusion.Data.Timestamp/index.js";
import * as Fusion_Entrypoint_Cross from "../Fusion.Entrypoint.Cross/index.js";
import * as Fusion_LoadOutput from "../Fusion.LoadOutput/index.js";
import * as Fusion_Ping from "../Fusion.Ping/index.js";
import * as Visonum_Cross_Capabilities from "../Visonum.Cross.Capabilities/index.js";
import * as Visonum_Cross_Components_App_Types_AppAction from "../Visonum.Cross.Components.App.Types.AppAction/index.js";
import * as Visonum_Cross_Components_App_Types_AppState from "../Visonum.Cross.Components.App.Types.AppState/index.js";
import * as Visonum_Cross_Components_App_Types_Page from "../Visonum.Cross.Components.App.Types.Page/index.js";
import * as Visonum_Cross_Data_Pixel from "../Visonum.Cross.Data.Pixel/index.js";
import * as Visonum_Cross_Default from "../Visonum.Cross.Default/index.js";
import * as Visonum_Cross_Embed from "../Visonum.Cross.Embed/index.js";
import * as Visonum_Cross_Extra_Lenses from "../Visonum.Cross.Extra.Lenses/index.js";
import * as Visonum_Cross_Types_UserConsent from "../Visonum.Cross.Types.UserConsent/index.js";
import * as Visonum_Cross_Views_Chart from "../Visonum.Cross.Views.Chart/index.js";
import * as WE_Class_Time from "../WE.Class.Time/index.js";
var prop = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "current";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop1 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "intermediates";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop2 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "totalSpeed";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop3 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "streamSpeeds";
    }
})()()(Data_Profunctor_Strong.strongFn);
var alter = /* #__PURE__ */ Data_Map_Internal.alter(Data_Ord.ordInt);
var prop4 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "statIntermediatesActive";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop5 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "statIntermediatesPassive";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop6 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "warnings";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop7 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "final";
    }
})()()(Data_Profunctor_Strong.strongFn);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var getStorage = /* #__PURE__ */ Visonum_Cross_Capabilities.getStorage();
var debugStateIsSymbol = {
    reflectSymbol: function () {
        return "debugState";
    }
};
var getStorage1 = /* #__PURE__ */ getStorage(debugStateIsSymbol)(Visonum_Cross_Components_App_Types_AppState.decodeJsonAppStateJ);
var _app = /* #__PURE__ */ Visonum_Cross_Components_App_Types_AppState["_app"](Data_Profunctor_Strong.strongFn);
var setStorage = /* #__PURE__ */ Visonum_Cross_Capabilities.setStorage();
var setStorage1 = /* #__PURE__ */ setStorage(debugStateIsSymbol)(Visonum_Cross_Components_App_Types_AppState.encodeJsonAppStateJ);
var def = /* #__PURE__ */ Visonum_Cross_Default.def(Visonum_Cross_Default.defaultMaybe);
var pageIsSymbol = {
    reflectSymbol: function () {
        return "page";
    }
};
var def1 = /* #__PURE__ */ Visonum_Cross_Default.def(/* #__PURE__ */ Visonum_Cross_Default.defaultRecord()(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(Visonum_Cross_Default.defaultRLNilRow)(Visonum_Cross_Default.defaultMaybe)()({
    reflectSymbol: function () {
        return "uploadDurationMillis";
    }
})())(Visonum_Cross_Default.defaultBoolean)()({
    reflectSymbol: function () {
        return "serverless";
    }
})())(Visonum_Cross_Default.defaultBoolean)()({
    reflectSymbol: function () {
        return "preserveState";
    }
})())(Visonum_Cross_Default.defaultMaybe)()({
    reflectSymbol: function () {
        return "pingDurationMillis";
    }
})())(Visonum_Cross_Default.defaultMaybe)()(pageIsSymbol)())(Visonum_Cross_Default.defaultMaybe)()({
    reflectSymbol: function () {
        return "maxUploadBookedSpeed";
    }
})())(Visonum_Cross_Default.defaultMaybe)()({
    reflectSymbol: function () {
        return "maxDownloadBookedSpeed";
    }
})())(Visonum_Cross_Default.defaultMaybe)()({
    reflectSymbol: function () {
        return "downloadDurationMillis";
    }
})())(Visonum_Cross_Default.defaultBoolean)()({
    reflectSymbol: function () {
        return "debug";
    }
})())(Visonum_Cross_Default.defaultMaybe)()({
    reflectSymbol: function () {
        return "brand";
    }
})()));
var prop8 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "download";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop9 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "upload";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop10 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "speedtestResult";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop11 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop(pageIsSymbol)()()(Data_Profunctor_Strong.strongFn);
var prop12 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "ping";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop13 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "running";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop14 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "prepare";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop15 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "error";
    }
})()()(Data_Profunctor_Strong.strongFn);
var foldl = /* #__PURE__ */ Data_Foldable.foldl(Data_Array_NonEmpty_Internal.foldableNonEmptyArray);
var prop16 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "speedtestRoute";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop17 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "scrollMode";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop18 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "speedtestStarted";
    }
})()()(Data_Profunctor_Strong.strongFn);
var consentIsSymbol = {
    reflectSymbol: function () {
        return "consent";
    }
};
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean));
var timestampIsSymbol = {
    reflectSymbol: function () {
        return "timestamp";
    }
};
var termsAndConditionsIsSymbol = {
    reflectSymbol: function () {
        return "termsAndConditions";
    }
};
var bugReportsIsSymbol = {
    reflectSymbol: function () {
        return "bugReports";
    }
};
var analyticsIsSymbol = {
    reflectSymbol: function () {
        return "analytics";
    }
};
var getStorage2 = /* #__PURE__ */ getStorage(consentIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Fusion_Data_Timestamp.decodeJsonTimestamp))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(timestampIsSymbol)()())(termsAndConditionsIsSymbol)()())(bugReportsIsSymbol)()())(analyticsIsSymbol)()())());
var prop19 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop(consentIsSymbol)()()(Data_Profunctor_Strong.strongFn);
var speedtestRoutesIsSymbol = {
    reflectSymbol: function () {
        return "speedtestRoutes";
    }
};
var gDecodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString));
var gDecodeJsonCons2 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt));
var useLocalEngineIsSymbol = {
    reflectSymbol: function () {
        return "useLocalEngine";
    }
};
var titleIsSymbol = {
    reflectSymbol: function () {
        return "title";
    }
};
var iconSourceIsSymbol = {
    reflectSymbol: function () {
        return "iconSource";
    }
};
var iconDestinationIsSymbol = {
    reflectSymbol: function () {
        return "iconDestination";
    }
};
var fieldStreamCountUploadIsSymbol = {
    reflectSymbol: function () {
        return "fieldStreamCountUpload";
    }
};
var fieldStreamCountDownloadIsSymbol = {
    reflectSymbol: function () {
        return "fieldStreamCountDownload";
    }
};
var fieldEngineUrlIsSymbol = {
    reflectSymbol: function () {
        return "fieldEngineUrl";
    }
};
var fieldDestinationUrlsIsSymbol = {
    reflectSymbol: function () {
        return "fieldDestinationUrls";
    }
};
var checkResultIsSymbol = {
    reflectSymbol: function () {
        return "checkResult";
    }
};
var getStorage3 = /* #__PURE__ */ getStorage(speedtestRoutesIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJsonNonEmptyArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonBoolean))(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons(Data_Argonaut_Decode_Class.gDecodeJsonNil)(useLocalEngineIsSymbol)()())(titleIsSymbol)()())(iconSourceIsSymbol)()())(iconDestinationIsSymbol)()())(fieldStreamCountUploadIsSymbol)()())(fieldStreamCountDownloadIsSymbol)()())(fieldEngineUrlIsSymbol)()())(fieldDestinationUrlsIsSymbol)()())(checkResultIsSymbol)()())()));
var prop20 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "pageSettings";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop21 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop(speedtestRoutesIsSymbol)()()(Data_Profunctor_Strong.strongFn);
var gEncodeJsonCons = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString);
var gEncodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt);
var gEncodeJsonCons2 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean);
var setStorage2 = /* #__PURE__ */ setStorage(speedtestRoutesIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonNonEmptyArray(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonJBoolean))(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons2(Data_Argonaut_Encode_Class.gEncodeJsonNil)(useLocalEngineIsSymbol)())(titleIsSymbol)())(iconSourceIsSymbol)())(iconDestinationIsSymbol)())(fieldStreamCountUploadIsSymbol)())(fieldStreamCountDownloadIsSymbol)())(fieldEngineUrlIsSymbol)())(fieldDestinationUrlsIsSymbol)())(checkResultIsSymbol)())()));
var setStorage3 = /* #__PURE__ */ setStorage(consentIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons2(/* #__PURE__ */ gEncodeJsonCons2(/* #__PURE__ */ gEncodeJsonCons2(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Fusion_Data_Timestamp.encodeJsonTimestamp))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(timestampIsSymbol)())(termsAndConditionsIsSymbol)())(bugReportsIsSymbol)())(analyticsIsSymbol)())());
var prop22 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "afterConsent";
    }
})()()(Data_Profunctor_Strong.strongFn);
var not = /* #__PURE__ */ Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
var zero = /* #__PURE__ */ Data_Semiring.zero(Visonum_Cross_Data_Pixel.semiringPixel);
var prop23 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "appSize";
    }
})()()(Data_Profunctor_Strong.strongFn);
var appModeIsSymbol = {
    reflectSymbol: function () {
        return "appMode";
    }
};
var setStorage4 = /* #__PURE__ */ setStorage(appModeIsSymbol)(Visonum_Cross_Components_App_Types_AppState.encodeJsonAppMode);
var prop24 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop(appModeIsSymbol)()()(Data_Profunctor_Strong.strongFn);
var prop25 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "pageMeasureResult";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop26 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "selectedTab";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop27 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "showWarnings";
    }
})()()(Data_Profunctor_Strong.strongFn);
var ix = /* #__PURE__ */ Data_Lens_Index.ix(Data_Lens_Index.indexNonEmptyArray);
var prop28 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop(titleIsSymbol)()()(Data_Profunctor_Strong.strongFn);
var prop29 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop(iconSourceIsSymbol)()()(Data_Profunctor_Strong.strongFn);
var prop30 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop(iconDestinationIsSymbol)()()(Data_Profunctor_Strong.strongFn);
var prop31 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop(fieldEngineUrlIsSymbol)()()(Data_Profunctor_Strong.strongFn);
var prop32 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop(fieldStreamCountDownloadIsSymbol)()()(Data_Profunctor_Strong.strongFn);
var prop33 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop(fieldStreamCountUploadIsSymbol)()()(Data_Profunctor_Strong.strongFn);
var prop34 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop(useLocalEngineIsSymbol)()()(Data_Profunctor_Strong.strongFn);
var prop35 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop(fieldDestinationUrlsIsSymbol)()()(Data_Profunctor_Strong.strongFn);
var prop36 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "pageDashboard";
    }
})()()(Data_Profunctor_Strong.strongFn);
var prop37 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "selectedSpeedtestRouteIndex";
    }
})()()(Data_Profunctor_Strong.strongFn);
var updateLoadResult = function (loadOutput) {
    return function (oldLoadResult) {
        if (loadOutput instanceof Fusion_LoadOutput.Current) {
            return Data_Lens_Setter.set(prop)(new Data_Maybe.Just(loadOutput.value0))(oldLoadResult);
        };
        if (loadOutput instanceof Fusion_LoadOutput.TotalIntermediate) {
            return Data_Lens_Setter.over(function ($634) {
                return prop1(prop2($634));
            })(function (v) {
                return Data_Array.snoc(v)(loadOutput.value0);
            })(oldLoadResult);
        };
        if (loadOutput instanceof Fusion_LoadOutput.StreamIntermediate) {
            return Data_Lens_Setter.over(function ($635) {
                return prop1(prop3($635));
            })(function (streamsMap) {
                var update = function (x) {
                    return new Data_Maybe.Just((function (v) {
                        return Data_Array.snoc(v)({
                            speed: loadOutput.value0.speed,
                            timestamp: loadOutput.value0.timestamp
                        });
                    })(Data_Maybe.fromMaybe([  ])(x)));
                };
                return alter(update)(loadOutput.value0.streamIndex)(streamsMap);
            })(oldLoadResult);
        };
        if (loadOutput instanceof Fusion_LoadOutput.IntermediateStatsActive) {
            return Data_Lens_Setter.over(prop4)(function (v) {
                return Data_Array.snoc(v)(loadOutput.value0.stats);
            })(oldLoadResult);
        };
        if (loadOutput instanceof Fusion_LoadOutput.IntermediateStatsPassive) {
            return Data_Lens_Setter.over(prop5)(function (v) {
                return Data_Array.snoc(v)(loadOutput.value0.stats);
            })(oldLoadResult);
        };
        if (loadOutput instanceof Fusion_LoadOutput.ServerSideLoadedBytes) {
            return oldLoadResult;
        };
        if (loadOutput instanceof Fusion_LoadOutput.ServerSideStreamIntermediate) {
            return oldLoadResult;
        };
        if (loadOutput instanceof Fusion_LoadOutput.ServerSideTotalIntermediate) {
            return oldLoadResult;
        };
        if (loadOutput instanceof Fusion_LoadOutput.Warning) {
            return Data_Lens_Setter.over(prop6)(function (v) {
                return Data_Array.snoc(v)(loadOutput.value0);
            })(oldLoadResult);
        };
        if (loadOutput instanceof Fusion_LoadOutput.Final) {
            return Data_Lens_Setter.set(prop7)(new Data_Maybe.Just(loadOutput.value0))(oldLoadResult);
        };
        throw new Error("Failed pattern match at Visonum.Cross.Components.App.HandleAction (line 367, column 3 - line 416, column 24): " + [ loadOutput.constructor.name ]);
    };
};
var restoreState = function (dictMonadApp) {
    var Monad0 = ((dictMonadApp.MonadBasicKill13()).MonadBasicFork0()).Monad0();
    var Bind1 = Monad0.Bind1();
    var discard1 = discard(Bind1);
    var log = Visonum_Cross_Capabilities.log(dictMonadApp.MonadLog2());
    var bind = Control_Bind.bind(Bind1);
    var MonadAppStorage10 = dictMonadApp.MonadAppStorage10();
    var getStorage4 = getStorage1(MonadAppStorage10);
    var ask = Control_Monad_Reader_Class.ask(dictMonadApp.MonadAsk11());
    var modify_ = Control_Monad_State_Class.modify_(dictMonadApp.MonadState0());
    var setStorage5 = setStorage1(MonadAppStorage10);
    var pure = Control_Applicative.pure(Monad0.Applicative0());
    return discard1(log("restoring state"))(function () {
        return bind(getStorage4)(function (eitherAppState) {
            return bind(ask)(function (v) {
                if (eitherAppState instanceof Data_Either.Right) {
                    return modify_(Data_Lens_Setter.set(_app)(eitherAppState.value0));
                };
                if (eitherAppState instanceof Data_Either.Left) {
                    return discard1(log("error restoring state: " + Visonum_Cross_Capabilities.printLocalStorageError(eitherAppState.value0)))(function () {
                        return discard1(setStorage5(Visonum_Cross_Components_App_Types_AppState.initialState({
                            brand: def,
                            commonQuery: def1,
                            destinationUrls: v.envVarsCross.FUSION_BASE_URLS,
                            embedOpts: Visonum_Cross_Embed.defaultEmbedOpts
                        })))(function () {
                            return pure(Data_Unit.unit);
                        });
                    });
                };
                throw new Error("Failed pattern match at Visonum.Cross.Components.App.HandleAction (line 475, column 3 - line 488, column 16): " + [ eitherAppState.constructor.name ]);
            });
        });
    });
};
var handleSpeedtestEventLoad = function (loadType) {
    return function (newLoadOutput) {
        return function (oldState) {
            var propLoad = (function () {
                if (loadType instanceof Data_LoadDirection.Download) {
                    return prop8;
                };
                if (loadType instanceof Data_LoadDirection.Upload) {
                    return prop9;
                };
                throw new Error("Failed pattern match at Visonum.Cross.Components.App.HandleAction (line 421, column 16 - line 423, column 31): " + [ loadType.constructor.name ]);
            })();
            var newState = Data_Lens_Setter.over(function ($636) {
                return prop10(propLoad($636));
            })(updateLoadResult(newLoadOutput))(oldState);
            if (newLoadOutput instanceof Fusion_LoadOutput.Current) {
                return newState;
            };
            if (newLoadOutput instanceof Fusion_LoadOutput.TotalIntermediate) {
                return newState;
            };
            if (newLoadOutput instanceof Fusion_LoadOutput.StreamIntermediate) {
                return newState;
            };
            if (newLoadOutput instanceof Fusion_LoadOutput.IntermediateStatsActive) {
                return newState;
            };
            if (newLoadOutput instanceof Fusion_LoadOutput.IntermediateStatsPassive) {
                return newState;
            };
            if (newLoadOutput instanceof Fusion_LoadOutput.ServerSideLoadedBytes) {
                return oldState;
            };
            if (newLoadOutput instanceof Fusion_LoadOutput.ServerSideStreamIntermediate) {
                return oldState;
            };
            if (newLoadOutput instanceof Fusion_LoadOutput.ServerSideTotalIntermediate) {
                return oldState;
            };
            if (newLoadOutput instanceof Fusion_LoadOutput.Warning) {
                return newState;
            };
            if (newLoadOutput instanceof Fusion_LoadOutput.Final) {
                if (loadType instanceof Data_LoadDirection.Upload) {
                    return Data_Lens_Setter.set(prop11)(Visonum_Cross_Components_App_Types_Page.PageMeasurePing.value)(Data_Lens_Setter.set(function ($637) {
                        return prop10(prop12(prop13($637)));
                    })(true)(Data_Lens_Setter.set(function ($638) {
                        return prop10(prop9(prop13($638)));
                    })(false)(newState)));
                };
                if (loadType instanceof Data_LoadDirection.Download) {
                    return Data_Lens_Setter.set(prop11)(Visonum_Cross_Components_App_Types_Page.PageMeasureUpload.value)(Data_Lens_Setter.set(function ($639) {
                        return prop10(prop9(prop13($639)));
                    })(true)(newState));
                };
                throw new Error("Failed pattern match at Visonum.Cross.Components.App.HandleAction (line 450, column 22 - line 468, column 36): " + [ loadType.constructor.name ]);
            };
            throw new Error("Failed pattern match at Visonum.Cross.Components.App.HandleAction (line 430, column 5 - line 468, column 36): " + [ newLoadOutput.constructor.name ]);
        };
    };
};
var handleSpeedtestEventFS = function (timestamp) {
    return function (fsValue) {
        return function (state) {
            if (fsValue instanceof Fusion_Data_FSValue.PrepareResult) {
                return Data_Lens_Setter.set(function ($640) {
                    return prop10(prop14($640));
                })(new Data_Maybe.Just(fsValue.value0))(state);
            };
            if (fsValue instanceof Fusion_Data_FSValue.DownloadIntermediate) {
                return state;
            };
            if (fsValue instanceof Fusion_Data_FSValue.DownloadFinal) {
                return state;
            };
            if (fsValue instanceof Fusion_Data_FSValue.FusionDownloadOutput) {
                return state;
            };
            if (fsValue instanceof Fusion_Data_FSValue.UploadIntermediate) {
                return state;
            };
            if (fsValue instanceof Fusion_Data_FSValue.UploadFinal) {
                return state;
            };
            if (fsValue instanceof Fusion_Data_FSValue.PingIntermediate) {
                return state;
            };
            if (fsValue instanceof Fusion_Data_FSValue.PingFinal) {
                return state;
            };
            if (fsValue instanceof Fusion_Data_FSValue.ModemFinal) {
                return state;
            };
            if (fsValue instanceof Fusion_Data_FSValue.Warning) {
                return state;
            };
            throw new Error("Failed pattern match at Visonum.Cross.Components.App.HandleAction (line 339, column 50 - line 363, column 25): " + [ fsValue.constructor.name ]);
        };
    };
};
var handlePing = function (po) {
    return function (state) {
        var _ping = function ($641) {
            return prop10(prop12($641));
        };
        if (po instanceof Fusion_Ping.PingIntermediate) {
            return Data_Lens_Setter.over(function ($642) {
                return _ping(prop1($642));
            })(function (v) {
                return Data_Array.snoc(v)(po.value0);
            })(state);
        };
        if (po instanceof Fusion_Ping.PingFinal) {
            return Data_Lens_Setter.set(prop11)(Visonum_Cross_Components_App_Types_Page.PageMeasureResult.value)(Data_Lens_Setter.set(function ($643) {
                return _ping(prop13($643));
            })(false)(Data_Lens_Setter.set(function ($644) {
                return _ping(prop7($644));
            })(new Data_Maybe.Just(po.value0))(state)));
        };
        throw new Error("Failed pattern match at Visonum.Cross.Components.App.HandleAction (line 321, column 5 - line 336, column 30): " + [ po.constructor.name ]);
    };
};
var updateSpeedtestEvent = function (timestamp) {
    return function (event) {
        return function (state) {
            if (event instanceof Data_Either.Left) {
                return Data_Lens_Setter.set(prop11)((function () {
                    var $565 = Fusion_Data_FSError.isClient(event.value0.scheme);
                    if ($565) {
                        return Visonum_Cross_Components_App_Types_Page.PageError.value;
                    };
                    return Visonum_Cross_Components_App_Types_Page.PageMeasureResult.value;
                })())(Data_Lens_Setter.set(function ($645) {
                    return prop10(prop15($645));
                })(new Data_Maybe.Just(event.value0))(state));
            };
            if (event instanceof Data_Either.Right) {
                if (event.value0 instanceof Fusion_Entrypoint_Cross.CrossDownload) {
                    return handleSpeedtestEventLoad(Data_LoadDirection.Download.value)(event.value0.value0)(state);
                };
                if (event.value0 instanceof Fusion_Entrypoint_Cross.CrossUpload) {
                    return handleSpeedtestEventLoad(Data_LoadDirection.Upload.value)(event.value0.value0)(state);
                };
                if (event.value0 instanceof Fusion_Entrypoint_Cross.CrossPing) {
                    return handlePing(event.value0.value0)(state);
                };
                if (event.value0 instanceof Fusion_Entrypoint_Cross.CrossFSValue) {
                    return handleSpeedtestEventFS(timestamp)(event.value0.value0)(state);
                };
                throw new Error("Failed pattern match at Visonum.Cross.Components.App.HandleAction (line 303, column 7 - line 314, column 53): " + [ event.value0.constructor.name ]);
            };
            throw new Error("Failed pattern match at Visonum.Cross.Components.App.HandleAction (line 295, column 3 - line 314, column 53): " + [ event.constructor.name ]);
        };
    };
};
var handleSpeedtestEventBatch = function (dictMonadApp) {
    var bind = Control_Bind.bind((((dictMonadApp.MonadBasicKill13()).MonadBasicFork0()).Monad0()).Bind1());
    var now = WE_Class_Time.now(dictMonadApp.MonadTime4());
    var modify_ = Control_Monad_State_Class.modify_(dictMonadApp.MonadState0());
    return function (events) {
        return bind(now)(function (timestamp) {
            return modify_(Data_Lens_Setter.over(_app)(function (state) {
                return foldl(function (st) {
                    return function (ev) {
                        return updateSpeedtestEvent(timestamp)(ev)(st);
                    };
                })(state)(events);
            }));
        });
    };
};
var $$goto = function (dictMonadApp) {
    var modify_ = Control_Monad_State_Class.modify_(dictMonadApp.MonadState0());
    return function (newPage) {
        return modify_(Data_Lens_Setter.set(function ($646) {
            return _app(prop11($646));
        })(newPage));
    };
};
var startSpeedtest = function (dictMonadApp) {
    var Bind1 = (((dictMonadApp.MonadBasicKill13()).MonadBasicFork0()).Monad0()).Bind1();
    var discard1 = discard(Bind1);
    var MonadSpeedtest5 = dictMonadApp.MonadSpeedtest5();
    var bind = Control_Bind.bind(Bind1);
    var now = WE_Class_Time.now(dictMonadApp.MonadTime4());
    var MonadState0 = dictMonadApp.MonadState0();
    var get = Control_Monad_State_Class.get(MonadState0);
    var modify_ = Control_Monad_State_Class.modify_(MonadState0);
    var goto1 = $$goto(dictMonadApp);
    var runSpeedtest = Visonum_Cross_Capabilities.runSpeedtest(MonadSpeedtest5);
    return discard1(Visonum_Cross_Capabilities.cancelSpeedtest(MonadSpeedtest5))(function () {
        return bind(now)(function (timestamp) {
            return bind(get)(function (state) {
                var speedtestRoute = Visonum_Cross_Components_App_Types_AppState.getSelectedSpeedtestRoute(state.app);
                return discard1(modify_(function (state1) {
                    return Data_Lens_Setter.set(function ($647) {
                        return _app(prop10(prop16($647)));
                    })(speedtestRoute)(Data_Lens_Setter.set(function ($648) {
                        return _app(prop10($648));
                    })(Visonum_Cross_Components_App_Types_AppState.initialSpeedtestResults)(Data_Lens_Setter.set(function ($649) {
                        return _app(prop17($649));
                    })(Visonum_Cross_Components_App_Types_AppState.AutoScroll.value)(Data_Lens_Setter.set(function ($650) {
                        return _app(prop18($650));
                    })(new Data_Maybe.Just(timestamp))(state1))));
                }))(function () {
                    return bind(get)(function (state1) {
                        var v = Visonum_Cross_Components_App_Types_AppState.getSelectedSpeedtestRoute(state1.app);
                        if (v instanceof Data_Maybe.Nothing) {
                            return goto1(Visonum_Cross_Components_App_Types_Page.PageError.value);
                        };
                        if (v instanceof Data_Maybe.Just) {
                            return discard1(runSpeedtest({
                                engineType: v.value0.engineType,
                                baseUrls: v.value0.destinations,
                                numDownloadStreams: v.value0.numDownloadStreams,
                                numUploadStreams: v.value0.numUploadStreams,
                                downloadDuration: Data_Maybe.fromMaybe(Fusion_Data_Duration.fromMs(10000.0))(state1.app.commonQuery.downloadDurationMillis),
                                uploadDuration: Data_Maybe.fromMaybe(Fusion_Data_Duration.fromMs(10000.0))(state1.app.commonQuery.uploadDurationMillis),
                                pingDuration: Data_Maybe.fromMaybe(Fusion_Data_Duration.fromMs(10000.0))(state1.app.commonQuery.pingDurationMillis)
                            })(Visonum_Cross_Components_App_Types_AppAction.SpeedtestEventBatch.create))(function () {
                                return discard1(modify_(function (state2) {
                                    return Data_Lens_Setter.set(function ($651) {
                                        return _app(prop10(prop8(prop13($651))));
                                    })(true)(state2);
                                }))(function () {
                                    return goto1(Visonum_Cross_Components_App_Types_Page.PageMeasureDownload.value);
                                });
                            });
                        };
                        throw new Error("Failed pattern match at Visonum.Cross.Components.App.HandleAction (line 515, column 3 - line 535, column 31): " + [ v.constructor.name ]);
                    });
                });
            });
        });
    });
};
var handleAction = function (dictMonadApp) {
    var Monad0 = ((dictMonadApp.MonadBasicKill13()).MonadBasicFork0()).Monad0();
    var Bind1 = Monad0.Bind1();
    var discard1 = discard(Bind1);
    var bind = Control_Bind.bind(Bind1);
    var MonadState0 = dictMonadApp.MonadState0();
    var get = Control_Monad_State_Class.get(MonadState0);
    var Applicative0 = Monad0.Applicative0();
    var when = Control_Applicative.when(Applicative0);
    var restoreState1 = restoreState(dictMonadApp);
    var mapFlipped = Data_Functor.mapFlipped((Bind1.Apply0()).Functor0());
    var MonadAppStorage10 = dictMonadApp.MonadAppStorage10();
    var getStorage4 = getStorage2(MonadAppStorage10);
    var modify_ = Control_Monad_State_Class.modify_(MonadState0);
    var getStorage5 = getStorage3(MonadAppStorage10);
    var setStorage5 = setStorage2(MonadAppStorage10);
    var watchElementResize = Visonum_Cross_Capabilities.watchElementResize(dictMonadApp.MonadWatchElementSize7());
    var now = WE_Class_Time.now(dictMonadApp.MonadTime4());
    var setStorage6 = setStorage3(MonadAppStorage10);
    var gets = Control_Monad_State_Class.gets(MonadState0);
    var goto1 = $$goto(dictMonadApp);
    var startSpeedtest1 = startSpeedtest(dictMonadApp);
    var pure = Control_Applicative.pure(Applicative0);
    var cancelSpeedtest = Visonum_Cross_Capabilities.cancelSpeedtest(dictMonadApp.MonadSpeedtest5());
    var scrollElement = Visonum_Cross_Capabilities.scrollElement(dictMonadApp.MonadScrollElement6());
    var handleSpeedtestEventBatch1 = handleSpeedtestEventBatch(dictMonadApp);
    var log = Visonum_Cross_Capabilities.log(dictMonadApp.MonadLog2());
    var setStorage7 = setStorage4(MonadAppStorage10);
    var ask = Control_Monad_Reader_Class.ask(dictMonadApp.MonadAsk11());
    var unless = Control_Applicative.unless(Applicative0);
    var setStorage8 = setStorage1(MonadAppStorage10);
    return function (ac) {
        return discard1((function () {
            if (ac instanceof Visonum_Cross_Components_App_Types_AppAction.Init) {
                return bind(get)(function (v) {
                    return discard1(when(v.app.commonQuery.preserveState)(restoreState1))(function () {
                        return bind(mapFlipped(getStorage4)(Data_Either.fromRight(Visonum_Cross_Types_UserConsent.initUserConsent)))(function (v1) {
                            return discard1(modify_(Data_Lens_Setter.set(function ($652) {
                                return _app(prop19($652));
                            })(v1)))(function () {
                                return bind(getStorage5)(function (eitherSpeedtestRoutes) {
                                    return discard1((function () {
                                        if (eitherSpeedtestRoutes instanceof Data_Either.Right) {
                                            return modify_(Data_Lens_Setter.set(function ($653) {
                                                return _app(prop20(prop21($653)));
                                            })(eitherSpeedtestRoutes.value0));
                                        };
                                        if (eitherSpeedtestRoutes instanceof Data_Either.Left) {
                                            return bind(get)(function (v2) {
                                                return setStorage5(v2.app.pageSettings.speedtestRoutes);
                                            });
                                        };
                                        throw new Error("Failed pattern match at Visonum.Cross.Components.App.HandleAction (line 67, column 7 - line 72, column 56): " + [ eitherSpeedtestRoutes.constructor.name ]);
                                    })())(function () {
                                        return watchElementResize("app")(Visonum_Cross_Components_App_Types_AppAction.NewAppSize.create);
                                    });
                                });
                            });
                        });
                    });
                });
            };
            if (ac instanceof Visonum_Cross_Components_App_Types_AppAction.SetConsentBugReports) {
                return bind(mapFlipped(getStorage4)(Data_Either.fromRight(Visonum_Cross_Types_UserConsent.initUserConsent)))(function (v) {
                    return bind(now)(function (timestamp) {
                        var newConsent = {
                            analytics: v.analytics,
                            termsAndConditions: v.termsAndConditions,
                            bugReports: ac.value0,
                            timestamp: new Data_Maybe.Just(timestamp)
                        };
                        return discard1(setStorage6(newConsent))(function () {
                            return modify_(Data_Lens_Setter.set(function ($654) {
                                return _app(prop19($654));
                            })(newConsent));
                        });
                    });
                });
            };
            if (ac instanceof Visonum_Cross_Components_App_Types_AppAction.SetConsentAnalytics) {
                return bind(mapFlipped(getStorage4)(Data_Either.fromRight(Visonum_Cross_Types_UserConsent.initUserConsent)))(function (v) {
                    return bind(now)(function (timestamp) {
                        var newConsent = {
                            bugReports: v.bugReports,
                            termsAndConditions: v.termsAndConditions,
                            analytics: ac.value0,
                            timestamp: new Data_Maybe.Just(timestamp)
                        };
                        return discard1(setStorage6(newConsent))(function () {
                            return modify_(Data_Lens_Setter.set(function ($655) {
                                return _app(prop19($655));
                            })(newConsent));
                        });
                    });
                });
            };
            if (ac instanceof Visonum_Cross_Components_App_Types_AppAction.SetConsentTermsAndConditions) {
                return bind(mapFlipped(getStorage4)(Data_Either.fromRight(Visonum_Cross_Types_UserConsent.initUserConsent)))(function (v) {
                    return bind(now)(function (timestamp) {
                        var newConsent = {
                            analytics: v.analytics,
                            bugReports: v.bugReports,
                            termsAndConditions: ac.value0,
                            timestamp: new Data_Maybe.Just(timestamp)
                        };
                        return discard1(setStorage6(newConsent))(function () {
                            return modify_(Data_Lens_Setter.set(function ($656) {
                                return _app(prop19($656));
                            })(newConsent));
                        });
                    });
                });
            };
            if (ac instanceof Visonum_Cross_Components_App_Types_AppAction.LeaveConsentPage) {
                return bind(gets(function (v) {
                    return v.app;
                }))(function (v) {
                    if (v.consent.termsAndConditions) {
                        if (v.afterConsent instanceof Visonum_Cross_Components_App_Types_AppState.AfterConsentSettings) {
                            return goto1(Visonum_Cross_Components_App_Types_Page.PageSettings.value);
                        };
                        if (v.afterConsent instanceof Visonum_Cross_Components_App_Types_AppState.AfterConsentSpeedtest) {
                            return startSpeedtest1;
                        };
                        throw new Error("Failed pattern match at Visonum.Cross.Components.App.HandleAction (line 126, column 9 - line 128, column 50): " + [ v.afterConsent.constructor.name ]);
                    };
                    return pure(Data_Unit.unit);
                });
            };
            if (ac instanceof Visonum_Cross_Components_App_Types_AppAction.ShowConsentPage) {
                return discard1(modify_(Data_Lens_Setter.set(function ($657) {
                    return _app(prop22($657));
                })(Visonum_Cross_Components_App_Types_AppState.AfterConsentSettings.value)))(function () {
                    return goto1(Visonum_Cross_Components_App_Types_Page.PageSplashConsent.value);
                });
            };
            if (ac instanceof Visonum_Cross_Components_App_Types_AppAction.StartSpeedtest) {
                return bind(gets(function (v) {
                    return v.app.consent;
                }))(function (consent) {
                    var $599 = !consent.termsAndConditions;
                    if ($599) {
                        return discard1(modify_(Data_Lens_Setter.set(function ($658) {
                            return _app(prop22($658));
                        })(Visonum_Cross_Components_App_Types_AppState.AfterConsentSpeedtest.value)))(function () {
                            return goto1(Visonum_Cross_Components_App_Types_Page.PageSplashConsent.value);
                        });
                    };
                    return startSpeedtest1;
                });
            };
            if (ac instanceof Visonum_Cross_Components_App_Types_AppAction.CancelSpeedtest) {
                return discard1(cancelSpeedtest)(function () {
                    return goto1(Visonum_Cross_Components_App_Types_Page.PageDashboard.value);
                });
            };
            if (ac instanceof Visonum_Cross_Components_App_Types_AppAction.SpeedtestEventBatch) {
                return bind(gets(function (v) {
                    return v.app.scrollMode;
                }))(function (scrollMode) {
                    return discard1((function () {
                        if (scrollMode instanceof Visonum_Cross_Components_App_Types_AppState.ManualScroll) {
                            return pure(Data_Unit.unit);
                        };
                        if (scrollMode instanceof Visonum_Cross_Components_App_Types_AppState.AutoScroll) {
                            return discard1(scrollElement({
                                id: "chart_static_panel",
                                x: 1000.0,
                                y: zero
                            }))(function () {
                                return pure(Data_Unit.unit);
                            });
                        };
                        throw new Error("Failed pattern match at Visonum.Cross.Components.App.HandleAction (line 154, column 7 - line 158, column 20): " + [ scrollMode.constructor.name ]);
                    })())(function () {
                        return handleSpeedtestEventBatch1(ac.value0);
                    });
                });
            };
            if (ac instanceof Visonum_Cross_Components_App_Types_AppAction.SetScrollMode) {
                return modify_(Data_Lens_Setter.set(function ($659) {
                    return _app(prop17($659));
                })(ac.value0));
            };
            if (ac instanceof Visonum_Cross_Components_App_Types_AppAction.ChartMsg) {
                if (ac.value0 instanceof Visonum_Cross_Views_Chart.ScrollUser) {
                    return modify_(Data_Lens_Setter.set(function ($660) {
                        return _app(prop17($660));
                    })(Visonum_Cross_Components_App_Types_AppState.ManualScroll.value));
                };
                if (ac.value0 instanceof Visonum_Cross_Views_Chart.ScrollAuto) {
                    return modify_(Data_Lens_Setter.set(function ($661) {
                        return _app(prop17($661));
                    })(Visonum_Cross_Components_App_Types_AppState.AutoScroll.value));
                };
                if (ac.value0 instanceof Visonum_Cross_Views_Chart.NewElem) {
                    return log("elem");
                };
                throw new Error("Failed pattern match at Visonum.Cross.Components.App.HandleAction (line 166, column 7 - line 172, column 21): " + [ ac.value0.constructor.name ]);
            };
            if (ac instanceof Visonum_Cross_Components_App_Types_AppAction.NewAppSize) {
                return modify_(Data_Lens_Setter.set(function ($662) {
                    return _app(prop23($662));
                })(ac.value0));
            };
            if (ac instanceof Visonum_Cross_Components_App_Types_AppAction.SetAppMode) {
                return discard1(setStorage7(ac.value0))(function () {
                    return modify_(Data_Lens_Setter.set(function ($663) {
                        return _app(prop24($663));
                    })(ac.value0));
                });
            };
            if (ac instanceof Visonum_Cross_Components_App_Types_AppAction.PageMeasureResultMsg) {
                if (ac.value0 instanceof Visonum_Cross_Components_App_Types_AppAction.SetTab) {
                    return modify_(Data_Lens_Setter.set(function ($664) {
                        return _app(prop25(prop26($664)));
                    })(ac.value0.value0));
                };
                if (ac.value0 instanceof Visonum_Cross_Components_App_Types_AppAction.ToggleWarnings) {
                    return modify_(Data_Lens_Setter.over(function ($665) {
                        return _app(prop25(prop27($665)));
                    })(not));
                };
                throw new Error("Failed pattern match at Visonum.Cross.Components.App.HandleAction (line 182, column 7 - line 190, column 16): " + [ ac.value0.constructor.name ]);
            };
            if (ac instanceof Visonum_Cross_Components_App_Types_AppAction.ChangeMenu) {
                if (ac.value0 instanceof Visonum_Cross_Components_App_Types_AppAction.Dashboard) {
                    return goto1(Visonum_Cross_Components_App_Types_Page.PageDashboard.value);
                };
                if (ac.value0 instanceof Visonum_Cross_Components_App_Types_AppAction.Results) {
                    return goto1(Visonum_Cross_Components_App_Types_Page.PageMeasureResult.value);
                };
                if (ac.value0 instanceof Visonum_Cross_Components_App_Types_AppAction.About) {
                    return goto1(Visonum_Cross_Components_App_Types_Page.PageAbout.value);
                };
                if (ac.value0 instanceof Visonum_Cross_Components_App_Types_AppAction.Settings) {
                    return goto1(Visonum_Cross_Components_App_Types_Page.PageSettings.value);
                };
                throw new Error("Failed pattern match at Visonum.Cross.Components.App.HandleAction (line 192, column 23 - line 200, column 26): " + [ ac.value0.constructor.name ]);
            };
            if (ac instanceof Visonum_Cross_Components_App_Types_AppAction.ResetApp) {
                return bind(ask)(function (v) {
                    return bind(get)(function (state) {
                        return discard1(unless(state.app.commonQuery.preserveState)(modify_(Data_Lens_Setter.set(_app)(Visonum_Cross_Components_App_Types_AppState.initialState({
                            brand: def,
                            commonQuery: def1,
                            destinationUrls: v.envVarsCross.FUSION_BASE_URLS,
                            embedOpts: Visonum_Cross_Embed.defaultEmbedOpts
                        })))))(function () {
                            return goto1(Visonum_Cross_Components_App_Types_Page.PageDashboard.value);
                        });
                    });
                });
            };
            if (ac instanceof Visonum_Cross_Components_App_Types_AppAction.PageSettingsAction) {
                return discard1((function () {
                    if (ac.value0 instanceof Visonum_Cross_Components_App_Types_AppAction.SetFieldTitle) {
                        return modify_(Data_Lens_Setter.set((function () {
                            var $666 = ix(ac.value0.value0)(Data_Profunctor_Strong.strongFn)(Data_Profunctor_Choice.choiceFn);
                            return function ($667) {
                                return _app(prop20(prop21($666(prop28($667)))));
                            };
                        })())(ac.value0.value1));
                    };
                    if (ac.value0 instanceof Visonum_Cross_Components_App_Types_AppAction.SetFieldSourceIcon) {
                        return modify_(Data_Lens_Setter.set((function () {
                            var $668 = ix(ac.value0.value0)(Data_Profunctor_Strong.strongFn)(Data_Profunctor_Choice.choiceFn);
                            return function ($669) {
                                return _app(prop20(prop21($668(prop29($669)))));
                            };
                        })())(ac.value0.value1));
                    };
                    if (ac.value0 instanceof Visonum_Cross_Components_App_Types_AppAction.SetFieldDestinationIcon) {
                        return modify_(Data_Lens_Setter.set((function () {
                            var $670 = ix(ac.value0.value0)(Data_Profunctor_Strong.strongFn)(Data_Profunctor_Choice.choiceFn);
                            return function ($671) {
                                return _app(prop20(prop21($670(prop30($671)))));
                            };
                        })())(ac.value0.value1));
                    };
                    if (ac.value0 instanceof Visonum_Cross_Components_App_Types_AppAction.SetFieldEngineUrl) {
                        return modify_(Data_Lens_Setter.set((function () {
                            var $672 = ix(ac.value0.value0)(Data_Profunctor_Strong.strongFn)(Data_Profunctor_Choice.choiceFn);
                            return function ($673) {
                                return _app(prop20(prop21($672(prop31($673)))));
                            };
                        })())(ac.value0.value1));
                    };
                    if (ac.value0 instanceof Visonum_Cross_Components_App_Types_AppAction.SetFieldSourceEngineStreamCount) {
                        return modify_(Data_Lens_Setter.set((function () {
                            var $674 = ix(ac.value0.value0)(Data_Profunctor_Strong.strongFn)(Data_Profunctor_Choice.choiceFn);
                            var $675 = (function () {
                                if (ac.value0.value1 instanceof Data_LoadDirection.Download) {
                                    return prop32;
                                };
                                if (ac.value0.value1 instanceof Data_LoadDirection.Upload) {
                                    return prop33;
                                };
                                throw new Error("Failed pattern match at Visonum.Cross.Components.App.HandleAction (line 250, column 23 - line 252, column 65): " + [ ac.value0.value1.constructor.name ]);
                            })();
                            return function ($676) {
                                return _app(prop20(prop21($674($675($676)))));
                            };
                        })())(ac.value0.value2));
                    };
                    if (ac.value0 instanceof Visonum_Cross_Components_App_Types_AppAction.SetUseLocalEngine) {
                        return modify_(Data_Lens_Setter.set((function () {
                            var $677 = ix(ac.value0.value0)(Data_Profunctor_Strong.strongFn)(Data_Profunctor_Choice.choiceFn);
                            return function ($678) {
                                return _app(prop20(prop21($677(prop34($678)))));
                            };
                        })())(ac.value0.value1));
                    };
                    if (ac.value0 instanceof Visonum_Cross_Components_App_Types_AppAction.SetFieldDestinationUrls) {
                        return modify_(Data_Lens_Setter.set((function () {
                            var $679 = ix(ac.value0.value0)(Data_Profunctor_Strong.strongFn)(Data_Profunctor_Choice.choiceFn);
                            return function ($680) {
                                return _app(prop20(prop21($679(prop35($680)))));
                            };
                        })())(ac.value0.value1));
                    };
                    throw new Error("Failed pattern match at Visonum.Cross.Components.App.HandleAction (line 217, column 7 - line 270, column 14): " + [ ac.value0.constructor.name ]);
                })())(function () {
                    return bind(get)(function (state) {
                        return setStorage5(state.app.pageSettings.speedtestRoutes);
                    });
                });
            };
            if (ac instanceof Visonum_Cross_Components_App_Types_AppAction.SelectSpeedtestRoute) {
                return modify_(Data_Lens_Setter.set(function ($681) {
                    return _app(prop36(prop37($681)));
                })(ac.value0));
            };
            throw new Error("Failed pattern match at Visonum.Cross.Components.App.HandleAction (line 50, column 3 - line 275, column 104): " + [ ac.constructor.name ]);
        })())(function () {
            return bind(get)(function (state) {
                return when(state.app.commonQuery.preserveState)(discard1(log("preserving state"))(function () {
                    return setStorage8(state.app);
                }));
            });
        });
    };
};
export {
    handleAction,
    restoreState,
    updateLoadResult
};
